export var defaultLayout_PPC = {
  name: 'olxin_valuation_flow_2',
  sections: [{
    name: 'header',
    title: null,
    subtitle: null,
    widgets: [{
      name: 'olxautos-header',
      templateName: 'OLXAutosHeader',
      data: {
        logo: {
          url: 'https://statics.olx.in/olxin/autos/landingPage/v1/light/olx-autos-logo.svg'
        }
      },
      metadata: null,
      errorState: null,
      dataLoadingContext: {
        loadingStrategy: 'STATIC',
        sources: null
      }
    }],
    sections: null,
    metadata: {
      style: {
        position: 'sticky'
      },
      alignment: 'horizontal',
      separator: false
    }
  }, {
    name: 'mobile-banner-section',
    title: null,
    subtitle: null,
    widgets: [{
      name: 'mobile-banner-widget',
      templateName: 'StaticImageWithCTA',
      data: {
        image: {
          url: '/olxin/autos/landingPage/v1/light/mobile_home_page_banner_ppc_$scalingParam$.$ext$',
          style: {
            aspectRatio: '180/83'
          }
        }
      },
      metadata: null,
      errorState: null,
      dataLoadingContext: {
        loadingStrategy: 'STATIC',
        sources: null
      }
    }],
    sections: null,
    metadata: {
      style: {
        paddingBottom: 0
      },
      alignment: 'horizontal',
      separator: false
    }
  }, {
    name: 'mobile-banner-valuation-section',
    title: null,
    subtitle: null,
    widgets: [{
      name: 'valuation_flow_widget',
      templateName: 'ValuationFlow',
      data: {
        title: {
          text: 'Quote Your Car',
          style: {
            height: '40px',
            display: 'flex',
            fontSize: '18px',
            marginTop: '-8px',
            textAlign: 'center',
            alignItems: 'center',
            background: 'white',
            fontWeight: 'bold',
            borderBottom: '1px solid #d8dfe0',
            borderRadius: '8px 8px 0 0',
            justifyContent: 'center'
          }
        },
        apiUrl: '/api/rocket/valuate/form-fields',
        subTitle: {
          text: 'Select the make of your car'
        }
      },
      metadata: {
        style: {},
        showNumberPlatePrefill: true
      },
      errorState: null,
      dataLoadingContext: {
        loadingStrategy: 'STATIC',
        sources: null
      }
    }],
    sections: null,
    metadata: {}
  }],
  metadata: {
    footer: {
      isVisible: false,
      showNavigationLinks: false
    },
    header: {
      isVisible: false,
      headerProps: {
        enableSearchInput: false,
        enableLocationMenu: false
      }
    },
    subHeader: {
      isVisible: false
    }
  },
  viewConfigName: 'olxin-web-mobile-default-valuationFlow-2'
};
export var defaultLayout_Organic = {
  name: 'olxin_valuation_flow_2',
  sections: [{
    name: 'header',
    title: null,
    subtitle: null,
    widgets: [{
      name: 'olxautos-header',
      templateName: 'OLXAutosHeader',
      data: {
        logo: {
          url: 'https://statics.olx.in/olxin/autos/landingPage/v1/light/olx-autos-logo.svg'
        }
      },
      metadata: null,
      errorState: null,
      dataLoadingContext: {
        loadingStrategy: 'STATIC',
        sources: null
      }
    }],
    sections: null,
    metadata: {
      style: {
        position: 'sticky'
      },
      alignment: 'horizontal',
      separator: false
    }
  }, {
    name: 'mobile-banner-section',
    title: null,
    subtitle: null,
    widgets: [{
      name: 'mobile-banner-widget',
      templateName: 'StaticImageWithCTA',
      data: {
        image: {
          url: '/olxin/autos/landingPage/v1/light/mobile_home_page_banner_ppc_$scalingParam$.$ext$',
          style: {
            aspectRatio: '180/83'
          }
        }
      },
      metadata: null,
      errorState: null,
      dataLoadingContext: {
        loadingStrategy: 'STATIC',
        sources: null
      }
    }],
    sections: null,
    metadata: {
      style: {
        paddingBottom: 0
      },
      alignment: 'horizontal',
      separator: false
    }
  }, {
    name: 'mobile-banner-valuation-section',
    title: null,
    subtitle: null,
    widgets: [{
      name: 'valuation_flow_widget',
      templateName: 'ValuationFlow',
      data: {
        title: {
          text: 'Quote Your Car',
          style: {
            height: '40px',
            display: 'flex',
            fontSize: '18px',
            marginTop: '-8px',
            textAlign: 'center',
            alignItems: 'center',
            background: 'white',
            fontWeight: 'bold',
            borderBottom: '1px solid #d8dfe0',
            borderRadius: '8px 8px 0 0',
            justifyContent: 'center'
          }
        },
        apiUrl: '/api/rocket/valuate/form-fields',
        subTitle: {
          text: 'Select the make of your car'
        }
      },
      metadata: {
        style: {},
        showNumberPlatePrefill: true
      },
      errorState: null,
      dataLoadingContext: {
        loadingStrategy: 'STATIC',
        sources: null
      }
    }],
    sections: null,
    metadata: {}
  }],
  metadata: {
    footer: {
      isVisible: false,
      showNavigationLinks: false
    },
    header: {
      isVisible: false,
      headerProps: {
        enableSearchInput: false,
        enableLocationMenu: false
      }
    },
    subHeader: {
      isVisible: false
    }
  },
  viewConfigName: 'olxin-web-mobile-default-valuationFlow-2'
};
export var defaultLayout_mobile_mx_cl = {
  name: 'olxcl_web_mobile',
  sections: [{
    name: 'mobile-banner-section',
    title: null,
    widgets: [{
      name: 'mobile-banner-widget',
      templateName: 'StaticImageWithCTA',
      data: {
        image: {
          url: '/olxcommx/autos/light/v1/banner-mobile@$scalingParam$.$ext$'
        }
      },
      metadata: null
    }],
    sections: null,
    metadata: {
      style: {
        paddingBottom: 0
      },
      alignment: 'horizontal',
      separator: false
    }
  }, {
    name: 'mobile-banner-valuation-section',
    title: null,
    widgets: [{
      name: 'valuation_flow_widget',
      templateName: 'ValuationFlow',
      data: {
        title: {
          text: 'Cotiza tu auto aquí',
          style: {
            height: '40px',
            display: 'flex',
            fontSize: '18px',
            marginTop: '-8px',
            textAlign: 'center',
            alignItems: 'center',
            background: 'white',
            fontWeight: 'bold',
            borderBottom: '1px solid #d8dfe0',
            borderRadius: '8px 8px 0 0',
            justifyContent: 'center'
          }
        },
        apiUrl: '/api/rocket/valuate/form-fields',
        subTitle: {
          text: 'Selecciona la marca de tu auto'
        }
      },
      metadata: {
        style: {},
        showNumberPlatePrefill: true
      }
    }],
    sections: null,
    metadata: {}
  }],
  metadata: {
    footer: {
      isVisible: false,
      showNavigationLinks: false
    },
    header: {
      isVisible: false
    }
  }
};
export var defaultLayout_mobile_olxid = {
  name: 'olxcl_web_mobile',
  sections: [{
    name: 'mobile-banner-section',
    title: null,
    widgets: [{
      name: 'mobile-banner-widget',
      templateName: 'StaticImageWithCTA',
      data: {
        image: {
          url: '/olxid/autos/landingPage/v1/light/PPC_Mobile@$scalingParam$.png'
        }
      },
      metadata: null
    }],
    sections: null,
    metadata: {
      style: {
        paddingBottom: 0
      },
      alignment: 'horizontal',
      separator: false
    }
  }, {
    name: 'mobile-banner-valuation-section',
    title: null,
    widgets: [{
      name: 'valuation_flow_widget',
      templateName: 'ValuationFlow',
      data: {
        title: {
          text: 'Kutip Mobil Anda',
          style: {
            height: '40px',
            display: 'flex',
            fontSize: '18px',
            marginTop: '-8px',
            textAlign: 'center',
            alignItems: 'center',
            background: 'white',
            fontWeight: 'bold',
            borderBottom: '1px solid #d8dfe0',
            borderRadius: '8px 8px 0 0',
            justifyContent: 'center'
          }
        },
        apiUrl: '/api/rocket/valuate/form-fields',
        subTitle: {
          text: 'Pilih merek mobil Anda'
        }
      },
      metadata: {
        style: {},
        showNumberPlatePrefill: true
      }
    }],
    sections: null,
    metadata: {}
  }],
  metadata: {
    footer: {
      isVisible: false,
      showNavigationLinks: false
    },
    header: {
      isVisible: false
    }
  }
};
export var defaultLayout_desktop_mx_cl = {
  name: 'olxcl_web_desktop',
  sections: [{
    name: 'desktop-banner-section',
    title: null,
    widgets: [{
      name: 'desktop-banner-widget',
      templateName: 'StaticImageWithCTA',
      data: {
        image: {
          url: '/olxcommx/autos/light/v1/banner-desktop@$scalingParam$.$ext$',
          style: {
            display: 'block'
          }
        }
      },
      metadata: null
    }],
    sections: null,
    metadata: {
      style: {
        paddingBottom: 0
      },
      alignment: 'horizontal',
      separator: false
    }
  }, {
    name: 'desktop-banner-valuation-section',
    title: null,
    widgets: [{
      name: 'valuation_flow_widget_desktop',
      templateName: 'ValuationFlow',
      data: {
        title: {
          text: 'Cotiza tu auto aquí',
          style: {
            display: 'flex',
            padding: '12px 0',
            fontSize: '22px',
            textAlign: 'center',
            alignItems: 'center',
            background: 'white',
            fontWeight: 'bold',
            lineHeight: '1.82',
            borderBottom: '1px solid #d8dfe0',
            borderRadius: '8px 8px 0 0',
            justifyContent: 'center'
          }
        },
        apiUrl: '/api/rocket/valuate/form-fields',
        subTitle: {
          text: 'Selecciona la marca de tu auto'
        }
      },
      metadata: null
    }],
    sections: null,
    metadata: {
      style: {
        top: '32px',
        right: '40px',
        width: '433px',
        height: '452px',
        position: 'absolute',
        borderRadius: '8px',
        backgroundColor: '#f2f4f5'
      },
      alignment: 'verticle',
      separator: false
    }
  }, {
    name: 'desktop-benefits-of-selling-section',
    title: {
      text: '¿Por qué elegirnos?',
      style: {
        padding: '50px 0',
        fontSize: '28px',
        fontWeight: 'bold'
      }
    },
    widgets: [{
      name: 'benefits-of-selling-desktop-widget',
      templateName: 'EqualWidthColumnStaticContent',
      data: [{
        image: {
          alt: 'Rápido',
          url: '/olxcommx/autos/light/v1/rapido.svg'
        },
        title: {
          text: 'Rápido'
        },
        subtitle: {
          text: 'Nos preocupamos por que tu tiempo lo ocupes en eso que realmente importa.'
        }
      }, {
        image: {
          alt: 'Sin trabas',
          url: '/olxcommx/autos/light/v1/rc-transfer.svg'
        },
        title: {
          text: 'Sin trabas'
        },
        subtitle: {
          text: 'Trabajamos todos los días para que puedas cambiar de auto libre de preocupaciones.'
        }
      }, {
        image: {
          alt: 'Confiable',
          url: '/olxcommx/autos/light/v1/confiable.svg'
        },
        title: {
          text: 'Confiable'
        },
        subtitle: {
          text: 'Sabemos que todo cambio genera dudas, por eso te brindamos la mayor seguridad en cada paso.'
        }
      }],
      metadata: {
        style: {
          margin: '0 8px',
          padding: '0 0 72px'
        }
      }
    }],
    sections: null,
    metadata: {
      style: {
        backgroundColor: '#f5f8ff'
      },
      alignment: 'horizontal',
      separator: false
    }
  }],
  metadata: {
    footer: {
      isVisible: true,
      showNavigationLinks: false
    },
    header: {
      isVisible: false
    }
  }
};
export var defaultLayout_desktop_olxid = {
  name: 'olxid_web_desktop',
  sections: [{
    name: 'desktop-banner-section',
    title: null,
    widgets: [{
      name: 'desktop-banner-widget',
      templateName: 'StaticImageWithCTA',
      data: {
        image: {
          url: '/olxid/autos/landingPage/v1/light/PPC_Desktop@$scalingParam$.$ext$',
          style: {
            display: 'block'
          }
        }
      },
      metadata: null
    }],
    sections: null,
    metadata: {
      style: {
        paddingBottom: 0
      },
      alignment: 'horizontal',
      separator: false
    }
  }, {
    name: 'desktop-banner-valuation-section',
    title: null,
    widgets: [{
      name: 'valuation_flow_widget_desktop',
      templateName: 'ValuationFlow',
      data: {
        title: {
          text: 'Isi detail mobil kamu',
          style: {
            display: 'flex',
            padding: '12px 0',
            fontSize: '22px',
            textAlign: 'center',
            alignItems: 'center',
            background: 'white',
            fontWeight: 'bold',
            lineHeight: '1.82',
            borderBottom: '1px solid #d8dfe0',
            borderRadius: '8px 8px 0 0',
            justifyContent: 'center'
          }
        },
        apiUrl: '/api/rocket/valuate/form-fields',
        subTitle: {
          text: 'Pilih merek mobil Anda'
        }
      },
      metadata: null
    }],
    sections: null,
    metadata: {
      style: {
        top: '32px',
        right: '40px',
        width: '433px',
        height: '452px',
        position: 'absolute',
        borderRadius: '8px',
        backgroundColor: '#f2f4f5'
      },
      alignment: 'verticle',
      separator: false
    }
  }, {
    name: 'desktop-benefits-of-selling-section',
    title: {
      text: 'Mengapa OLX Autos?',
      style: {
        padding: '50px 0',
        fontSize: '28px',
        fontWeight: 'bold'
      }
    },
    widgets: [{
      name: 'benefits-of-selling-desktop-widget',
      templateName: 'EqualWidthColumnStaticContent',
      data: [{
        image: {
          alt: 'Gratis inspeksi',
          url: '/olxid/autos/landingPage/v1/light/free-inspection.svg'
        },
        title: {
          text: 'Gratis inspeksi'
        },
        subtitle: {
          text: 'Book jadwal inspeksi di lokasi kami atau pilih home inspection.'
        }
      }, {
        image: {
          alt: 'Pembayaran instan',
          url: '/olxid/autos/landingPage/v1/light/instant-payment.svg'
        },
        title: {
          text: 'Pembayaran instan'
        },
        subtitle: {
          text: 'Setelah deal dengan harga penawaran, pembayaran langsung ditransfer.'
        }
      }, {
        image: {
          alt: 'Gratis cek harga awal',
          url: '/olxid/autos/landingPage/v1/light/price-estimation.svg'
        },
        title: {
          text: 'Gratis cek harga awal'
        },
        subtitle: {
          text: 'Masukkan data mobil dan dapatkan perkiraan harga jual.'
        }
      }],
      metadata: {
        style: {
          margin: '0 8px',
          padding: '0 0 72px'
        }
      }
    }],
    sections: null,
    metadata: {
      style: {
        backgroundColor: '#f5f8ff'
      },
      alignment: 'horizontal',
      separator: false
    }
  }],
  metadata: {
    footer: {
      isVisible: true,
      showNavigationLinks: false
    },
    header: {
      isVisible: false
    }
  }
};
export var defaultLayout_desktop_olxin = {
  name: 'web-desktop-organic-layout-HS-T1A1-T2B2-T5A2-T4C1',
  sections: [{
    name: 'desktop-banner-section',
    title: null,
    subtitle: null,
    widgets: [{
      name: 'desktop-banner-widget',
      templateName: 'StaticImageWithCTA',
      data: {
        image: {
          url: '/olxin/autos/landingPage/v1/light/banner_India_desktop@$scalingParam$.$ext$',
          style: {
            left: '50%',
            height: '516px',
            display: 'block',
            position: 'relative',
            transform: 'translateX(-50%)'
          }
        }
      },
      metadata: {
        style: {
          overflow: 'hidden'
        }
      },
      dataLoadingContext: {
        loadingStrategy: 'STATIC',
        sources: null
      }
    }],
    sections: null,
    metadata: {
      style: {
        paddingBottom: 0
      },
      alignment: 'horizontal',
      separator: false
    }
  }, {
    name: 'desktop-banner-valuation-section',
    title: null,
    subtitle: null,
    widgets: [{
      name: 'valuation_flow_widget_desktop',
      templateName: 'ValuationFlow',
      data: {
        title: {
          text: 'Fill in your car details',
          style: {
            display: 'flex',
            padding: '12px 0',
            fontSize: '22px',
            textAlign: 'center',
            alignItems: 'center',
            background: 'white',
            fontWeight: 'bold',
            lineHeight: '1.82',
            borderBottom: '1px solid #d8dfe0',
            borderRadius: '8px 8px 0 0',
            justifyContent: 'center'
          }
        },
        apiUrl: '/api/rocket/valuate/form-fields',
        subTitle: {
          text: 'Choose your car brand'
        }
      },
      metadata: null,
      dataLoadingContext: {
        loadingStrategy: 'STATIC',
        sources: null
      }
    }],
    sections: null,
    metadata: {
      style: {
        top: '33px',
        right: '40px',
        width: '433px',
        height: '468px',
        position: 'absolute',
        borderRadius: '8px',
        backgroundColor: '#f2f4f5'
      },
      alignment: 'vertical',
      separator: false,
      dynamic_data: 'eager'
    }
  }, {
    name: 'desktop-benefits-of-selling-section',
    title: {
      text: 'Why OLX Autos?',
      style: {
        padding: '50px 0',
        fontSize: '28px',
        fontWeight: 'bold'
      }
    },
    subtitle: null,
    widgets: [{
      name: 'benefits-of-selling-desktop-widget',
      templateName: 'EqualWidthColumnStaticContent',
      data: [{
        image: {
          alt: 'Free inspection',
          url: '/olxid/autos/landingPage/v1/light/free-inspection.svg'
        },
        title: {
          text: 'Free inspection'
        },
        subtitle: {
          text: 'Book an inspection schedule at our location or choose a home inspection.'
        }
      }, {
        image: {
          alt: 'Instant payment',
          url: '/olxid/autos/landingPage/v1/light/instant-payment.svg'
        },
        title: {
          text: 'Instant payment'
        },
        subtitle: {
          text: 'After dealing with the offer price, the payment is transferred immediately.'
        }
      }, {
        image: {
          alt: 'Hassle Free Document Transfer',
          url: '/olxin/autos/landingPage/v1/light/hassle_free_transfer.svg',
          style: {
            marginTop: '-10px',
            marginBottom: '-12px'
          }
        },
        title: {
          text: 'Hassle Free Document Transfer'
        },
        subtitle: {
          text: 'Enter the car data and get the estimated selling price.'
        }
      }],
      metadata: {
        style: {
          margin: '0 8px',
          padding: '0 0 72px'
        }
      },
      dataLoadingContext: {
        loadingStrategy: 'STATIC',
        sources: null
      }
    }],
    sections: null,
    metadata: {
      style: {
        backgroundColor: '#f5f8ff'
      },
      alignment: 'horizontal',
      separator: false
    }
  }],
  metadata: {
    footer: {
      isVisible: true,
      footerProps: {
        enableTopMobile: true,
        isOlxAutosLandingPage: true
      }
    },
    header: {
      isVisible: true,
      headerProps: {
        hideHamburger: true,
        hideSearchBar: true,
        withSubheader: true,
        isPaidCampaign: true,
        enableSearchInput: false,
        hideActionButtons: true,
        isOlxAutosLandingPage: true
      }
    },
    subHeader: {
      isVisible: false
    }
  },
  viewConfigName: 'olxin-web-desktop-organic-olxAutos-27'
};
export var defaultLayout_loading_mobile_mx_cl = {
  name: 'olxcl_web_mobile',
  sections: [{
    name: 'mobile-banner-loader-section',
    title: null,
    widgets: [{
      name: 'cxe_loader_widget',
      templateName: 'CXELoadingWidget',
      metadata: null
    }],
    sections: null,
    metadata: {
      style: {
        height: '440px'
      }
    }
  }],
  metadata: {
    footer: {
      isVisible: true,
      showNavigationLinks: false
    },
    header: {
      isVisible: true
    }
  }
};
export var defaultLayout_loading_desktop_mx_cl = {
  name: 'olxcl_web_desktop',
  sections: [{
    name: 'desktop-banner-loading-section',
    title: null,
    widgets: [{
      name: 'cxe_loader_widget',
      templateName: 'CXELoadingWidget',
      metadata: null
    }],
    sections: null,
    metadata: {
      style: {
        top: '32px',
        right: '40px',
        width: '433px',
        height: '452px',
        position: 'absolute',
        borderRadius: '8px',
        backgroundColor: '#f2f4f5'
      },
      alignment: 'verticle',
      separator: false
    }
  }],
  metadata: {
    footer: {
      isVisible: false,
      showNavigationLinks: false
    },
    header: {
      isVisible: false
    }
  }
};
export var defaultLayout_loading_mobile_mx_cl_buy_finance = {
  name: 'defaultLayout_loading_mobile_mx_cl_buy_finance',
  sections: [{
    name: 'page-loading-section',
    title: null,
    widgets: [{
      name: 'page-loading-widget',
      templateName: 'PageLoadingWidget',
      metadata: null
    }],
    sections: null,
    metadata: null
  }],
  metadata: {
    footer: {
      isVisible: true,
      showNavigationLinks: false
    },
    header: {
      isVisible: true
    }
  }
};
export var defaultLayout_loading_desktop_mx_cl_buy_finance = {
  name: 'defaultLayout_loading_desktop_mx_cl_buy_finance',
  sections: [{
    name: 'page-loading-section',
    title: null,
    widgets: [{
      name: 'page-loading-widget',
      templateName: 'PageLoadingWidget',
      metadata: null
    }],
    sections: null,
    metadata: null
  }],
  metadata: {
    footer: {
      isVisible: false,
      showNavigationLinks: false
    },
    header: {
      isVisible: false
    }
  }
};
export var defaultLayout_loading_mobile_olxin = {
  name: 'olxcl_web_mobile',
  sections: [{
    name: 'header',
    title: null,
    subtitle: null,
    widgets: [{
      name: 'olxautos-header',
      templateName: 'OLXAutosHeader',
      data: {
        logo: {
          url: 'https://statics.olx.in/olxin/autos/landingPage/v1/light/olx-autos-logo.svg'
        }
      },
      metadata: null,
      errorState: null,
      dataLoadingContext: {
        loadingStrategy: 'STATIC',
        sources: null
      }
    }],
    sections: null,
    metadata: {
      style: {
        position: 'sticky'
      },
      alignment: 'horizontal',
      separator: false
    }
  }, {
    name: 'mobile-banner-loader-section',
    title: null,
    widgets: [{
      name: 'cxe_loader_widget',
      templateName: 'CXELoadingWidget',
      metadata: null
    }],
    sections: null,
    metadata: {
      style: {
        height: '440px'
      }
    }
  }],
  metadata: {
    footer: {
      isVisible: false,
      showNavigationLinks: false
    },
    header: {
      isVisible: false
    }
  }
};
export default {
  defaultLayout_desktop_olxid: defaultLayout_desktop_olxid,
  defaultLayout_PPC: defaultLayout_PPC,
  defaultLayout_Organic: defaultLayout_Organic,
  defaultLayout_mobile_mx_cl: defaultLayout_mobile_mx_cl,
  defaultLayout_loading_mobile_mx_cl: defaultLayout_loading_mobile_mx_cl,
  defaultLayout_loading_desktop_mx_cl: defaultLayout_loading_desktop_mx_cl,
  defaultLayout_loading_mobile_mx_cl_buy_finance: defaultLayout_loading_mobile_mx_cl_buy_finance,
  defaultLayout_loading_desktop_mx_cl_buy_finance: defaultLayout_loading_desktop_mx_cl_buy_finance,
  defaultLayout_loading_mobile_olxin: defaultLayout_loading_mobile_olxin
};